import script from "./BaseList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseList.vue?vue&type=script&lang=ts&setup=true"

import "./BaseList.vue?vue&type=style&index=0&id=3f7a2524&lang=css"

export default script